import { BooleanCons, StringConst } from 'src/app/constants/const';

export class SigInRols {
    isDoctor: boolean;
    isAdvisor: boolean;
    isReporter: boolean;
    constructor() {
        this.isDoctor = BooleanCons.false;
        this.isAdvisor = BooleanCons.false;
        this.isReporter = BooleanCons.false;
    }
}

export class ConfirmOrderReqByRol {
    advisorName: string;
    emails: string;
    doctorName: string;
    create: string;
    constructor() {
        this.advisorName = StringConst.empty;
        this.emails = StringConst.empty;
        this.doctorName = StringConst.empty;
        this.create = StringConst.empty;
    }
}
